import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import ActionButton from 'Components/ActionButton';
import { equals } from 'ramda';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { useAppDispatch } from 'Store/index';
import { path } from 'Utility/ramdaReplacement';
import { dialogTitle, dialogContent, dialogActions, dialogCancel } from '../../../../../../config/theme/componentTheme';
import { actions } from '../../../../../../store/documents/actions';
import ParkinsonInfusion from '../RegimenDialog/Custom/ParkinsonInfusion';
import { isParkinsonInfusionType } from '../RegimenDialog/utils/isParkinsonInfusionType';

const ModifyLockedRegimenDialog = ({
  open,
  setOpenDialog,
  regimen,
  document,
  field,
}: IModifyLockedRegimenDialog): React.JSX.Element => {
  const [data, setData] = React.useState<any>(regimen[field]);
  const dispatch = useAppDispatch();

  const closeDialog = (): void => {
    setOpenDialog(false);
  };
  const submitChanges = (): void => {
    if (equals(regimen[field], data)) return;

    actions.modifyField({ name: 'medication', id: document._id }, document, { 'regimen.$.infusionDoses': data }, true, {
      id: regimen.id,
      idFieldName: 'id',
    })(dispatch);
    setOpenDialog(false);
  };

  return (
    <Dialog open={open} maxWidth="lg" fullWidth={true} PaperProps={{ square: true }}>
      <DialogTitle style={dialogTitle}>
        <FormattedMessage id="medication.regimen" />
      </DialogTitle>

      <DialogContent style={dialogContent}>
        {regimen.regimenType === 'custom' && !!isParkinsonInfusionType(document) ? (
          <ParkinsonInfusion
            type={isParkinsonInfusionType(document)}
            index={0}
            formData={{
              onChange: (values: TOnChangeValues): void => {
                const value = path(['regimen', 0, 'infusionDoses'], values);
                setData(value);
              },
              document: {
                regimen: [{ id: regimen.id, infusionDoses: data, strengths: regimen.strengths }],
              },
            }}
          />
        ) : null}
      </DialogContent>
      <DialogActions style={dialogActions}>
        <div style={dialogCancel} onClick={closeDialog}>
          <FormattedMessage id="general.cancel" />
        </div>
        <ActionButton text="general.accept" onClick={submitChanges} width={15} height={4} fontSize={16} />
      </DialogActions>
    </Dialog>
  );
};

type TFieldType = keyof Regimen;

interface IModifyLockedRegimenDialog {
  open: boolean;
  setOpenDialog: (open: boolean) => void;
  regimen: Regimen;
  document: IDocumentWithTypeV2<'medication'>;
  field: TFieldType;
}

export default ModifyLockedRegimenDialog;
